module.exports = __webpack_public_path__ + "static/media/china.d4e0f13d.png";